import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const GitBookComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__gitBook"
      width={size}
      height={size}
      viewBox="0 0 12 10"
      fill="none"
    >
      <path
        d="M5.4 7.88747C5.5875 7.88747 5.75625 8.03747 5.75625 8.24372C5.75625 8.43122 5.60625 8.59997 5.4 8.59997C5.2125 8.59997 5.04375 8.44997 5.04375 8.24372C5.04375 8.03747 5.2125 7.88747 5.4 7.88747ZM10.9125 5.71247C10.725 5.71247 10.5562 5.56247 10.5562 5.35622C10.5562 5.16872 10.7062 4.99997 10.9125 4.99997C11.1 4.99997 11.2687 5.14997 11.2687 5.35622C11.2687 5.54372 11.1 5.71247 10.9125 5.71247ZM10.9125 4.26872C10.3125 4.26872 9.825 4.75622 9.825 5.35622C9.825 5.46872 9.84375 5.58122 9.88125 5.69372L6.3 7.60622C6.09375 7.30622 5.75625 7.13747 5.4 7.13747C4.9875 7.13747 4.6125 7.38122 4.425 7.73747L1.2 6.04997C0.862496 5.86247 0.599996 5.31872 0.637496 4.79372C0.656246 4.53122 0.749996 4.32497 0.881246 4.24997C0.974996 4.19372 1.06875 4.21247 1.2 4.26872L1.21875 4.28747C2.08125 4.73747 4.875 6.19997 4.9875 6.25622C5.175 6.33122 5.26875 6.36872 5.5875 6.21872L11.3625 3.21872C11.4562 3.18122 11.55 3.10622 11.55 2.97497C11.55 2.80622 11.3812 2.73122 11.3812 2.73122C11.0437 2.58122 10.5375 2.33747 10.05 2.11247C9 1.62497 7.8 1.06247 7.275 0.781221C6.825 0.537471 6.45 0.743721 6.39375 0.781221L6.2625 0.837471C3.88125 2.03747 0.731246 3.59372 0.543746 3.70622C0.224996 3.89372 0.0187457 4.28747 -4.25708e-06 4.77497C-0.0375043 5.54372 0.356246 6.34997 0.918746 6.63122L4.33125 8.39372C4.40625 8.91872 4.875 9.33122 5.4 9.33122C6 9.33122 6.46875 8.86247 6.4875 8.26247L10.2375 6.23747C10.425 6.38747 10.6687 6.46247 10.9125 6.46247C11.5125 6.46247 12 5.97497 12 5.37497C12 4.75622 11.5125 4.26872 10.9125 4.26872Z"
        fill={colorVar}
      />
    </svg>
  );
};

export const GitBook = withIcon(GitBookComponent);
